var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page",attrs:{"id":"app"}},[(_vm.$root.loading)?_c('Loading'):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }